<template>
  <div id="users_trainings_list">
    <div class="right div--button ma-2">
      Filtered rows: {{ usersLength }}
    </div>
    <b-table :current-page="currentPage"
             :fields="fields"
             :items="users"
             :per-page="perPage"
             class="table-responsive"
             head-variant="light"
             hover
             outlined
             responsive
             striped>

      <template v-slot:top-row="{fields}">
        <proposal-filter :id="id"
                         v-model="users"
                         :fields="fields"
                         :not-include-key="['actions','ordinalNumber']"/>
      </template>

      <template v-slot:cell(ordinalNumber)="row">
        <base-column-ordinal-number v-bind="{index: row.index, perPage: perPage, currentPage: currentPage}"/>
      </template>

      <template v-slot:cell(training_data.safety_training)="row">
        {{ getTrainingValidThroughDate(row.item.training_data.safety_training) }}
      </template>

      <template v-slot:cell(training_data.safety_training.states.state)="row">
        <div v-if="hasProperty(row.item.training_data, 'safety_training')"
             class="center">
          <b-form-checkbox v-model="row.item.training_data.safety_training.states.state"
                           :disabled="true"/>
        </div>
        <div v-else
             class="center">
          <b-form-checkbox :disabled="true"
                           v-bind:value="false"/>
        </div>
      </template>

      <template v-slot:cell(actions)="row">
        <base-icon-button-send title="Go to user details"
                               @click="goToUser(row.index)"/>
      </template>

    </b-table>

    <b-table-footer v-model="isBusy"
                    :current-page="currentPage"
                    :data-length="usersLength"
                    :per-page="perPage"
                    @change-page="changePage">
      <template v-slot>
        <base-per-page-input v-model="perPage"/>
      </template>
    </b-table-footer>
  </div>
</template>

<script>
  import BaseColumnOrdinalNumber from '@/components/base-components/BaseColumnOrdinalNumber';
  import BaseIconButtonSend from '@/components/base-components/base-icons/BaseIconButtonSend';
  import BasePerPageInput from '@/components/base-components/BasePerPageInput';
  import BTableFooter from '@/components/BTableFooter';
  import ProposalFilter from '@/components/ProposalFilter';
  import { trainingsMixins } from '@/mixins/trainings';

  export default {
    name: 'UsersTrainingsList',
    components: {
      BaseIconButtonSend,
      BaseColumnOrdinalNumber,
      BasePerPageInput,
      BTableFooter,
      ProposalFilter,
    },
    mixins: [trainingsMixins],
    computed: {
      usersLength() {
        return this.users.length;
      },
    },
    props: {
      fields: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        isBusy: false,
        users: [],
        currentPage: 1,
        perPage: 20,
        id: 1,
      };
    },
    methods: {
      loadData() {
        this.toggleBusy();
        this.axios.get('/users/trainings')
          .then((response) => {
            this.users = response.data;
            this.$emit('setup-proposal', this.users);
            this.toggleBusy();
          });
      },
      changePage(val) {
        this.currentPage = val;
      },
      toggleBusy() {
        this.isBusy = !this.isBusy;
      },
      calculateRowIndex(index) {
        return index + (this.perPage * (this.currentPage - 1));
      },
      getTrainingValidThroughDate(safetyTraining) {
        const trainingDurationInMs = safetyTraining.training_duration;
        return this.getActiveToDate(safetyTraining, trainingDurationInMs);
      },
      goToUser(index) {
        const idx = this.calculateRowIndex(index);
        const userId = this.getId(this.users[idx]);
        this.$router.push(`/operational/users/${userId}/1`);
      },
    },
    created() {
      this.loadData();
    },
  };
</script>

<style scoped>
  .center {
    text-align: center;
  }
</style>
